// extracted by mini-css-extract-plugin
export default {"xSplit":"TimelineSection_xSplit__3HNyn","labelInput":"TimelineSection_labelInput__538cE"};